import { buildUrlWithLocalization } from '../utils';

const PATH = 'cart';

/**
 * @type {import('./index.d').CartAPI}
 */
export const CartAPI = {
  getAll: async () => {
    const response = await fetch(buildUrlWithLocalization('cart.js'), {
      method: 'GET',
    });

    return await response.json();
  },

  // Updated add function with selling_plan
  add: async (id, quantity = 1, sellingPlanId = null, properties = {}) => {
    const payload = {
      items: [
        {
          id,
          quantity,
          selling_plan: sellingPlanId,
          properties: sellingPlanId ? { ...properties, _boostPreOrder: true } : properties,
        },
      ],
    };

    return await fetch(buildUrlWithLocalization(`${PATH}/add.js`), {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
  },

  // Updated addMultiProductToCart function to handle array of products
  addMultiProductToCart: async (data) => {
    const payload = {
      items: data,
    };

    return await fetch(buildUrlWithLocalization(`${PATH}/add.js`), {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
  },

  change: async (id, quantity = 0) => {
    const payload = {
      id,
      quantity,
    };

    const response = await fetch(buildUrlWithLocalization(`${PATH}/change.js`), {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    return await response.json();
  },

  clearCart: async () => {
    const response = await fetch(buildUrlWithLocalization(`${PATH}/clear.js`), { method: 'POST' });
    return await response.json();
  },

  restoreCartIfNeeded: async () => {
    const backup = localStorage.getItem('backup_cart_items');

    if (!backup) {
      return;
    }

    const items = JSON.parse(backup);

    await CartAPI.clearCart();
    await CartAPI.addMultiProductToCart(items);

    localStorage.removeItem('backup_cart_items');
  },
};
